import { render, staticRenderFns } from "./familymembers.vue?vue&type=template&id=715118d2&scoped=true"
import script from "./familymembers.vue?vue&type=script&lang=js"
export * from "./familymembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715118d2",
  null
  
)

export default component.exports